var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliveryNo
    ? _c(
        "div",
        { staticClass: "panel-body" },
        [
          _c("div", { staticClass: "box-delivery-name m-b-md" }, [
            _c("div", { staticClass: "row" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-10 col-lg-7" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.deliveryName,
                      expression: "deliveryName",
                      modifiers: { trim: true }
                    }
                  ],
                  class: [
                    "form-control",
                    _vm.deliveryName ? "" : "bg-no-input"
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.deliveryName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.deliveryName = $event.target.value.trim()
                    },
                    blur: function($event) {
                      _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。"
                  )
                ]),
                _vm._v(" "),
                _vm.validateErrors.deliveryName.length
                  ? _c("div", { staticClass: "text-red" }, [
                      _c("b", [
                        _vm._v(_vm._s(_vm.validateErrors.deliveryName[0]))
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box-delivery-date m-b-md" }, [
            _c("div", { staticClass: "row" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-10 col-lg-6" },
                [
                  _c("date-picker", {
                    ref: "datepickerStart",
                    attrs: {
                      placeholder: "",
                      format: "YYYY/MM/DD",
                      "input-attr": { id: "delivery-date" },
                      lang: _vm.lang,
                      "not-before": _vm.todayFormatDate,
                      "input-class": [
                        "mx-input",
                        _vm.deliveryDate ? "" : "bg-no-input"
                      ]
                    },
                    model: {
                      value: _vm.deliveryDate,
                      callback: function($$v) {
                        _vm.deliveryDate = $$v
                      },
                      expression: "deliveryDate"
                    }
                  }),
                  _vm._v(" "),
                  _vm.validateErrors.deliveryDate.length
                    ? _c("div", { staticClass: "text-red" }, [
                        _c("b", [
                          _vm._v(_vm._s(_vm.validateErrors.deliveryDate[0]))
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box-origin-info-default m-b-sm" }, [
            _c("div", { staticClass: "row" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-9 col-lg-10" }, [
                _vm.deliverySellerInfo
                  ? _c("div", { staticClass: "delivery-info-default" }, [
                      _c("div", [_vm._v(_vm._s(_vm.deliverySellerInfo.name))]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.deliverySellerInfo.postalCode) +
                            "     " +
                            _vm._s(_vm.deliverySellerInfo.address) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(_vm.deliverySellerInfo.phoneNo))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "text--underline",
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.openModalDeliveryInfo()
                      }
                    }
                  },
                  [_vm._v("登録・変更はこちら")]
                ),
                _vm._v(" "),
                _vm.validateErrors.deliveryInfo.length
                  ? _c("div", { staticClass: "text-red" }, [
                      _c("b", [
                        _vm._v(_vm._s(_vm.validateErrors.deliveryInfo[0]))
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box-btn-selection-product" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary custom-btn-delivery",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.openModalDeliveryProductAdd()
                  }
                }
              },
              [_vm._v("商品選択")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box-selected-products m-t-lg m-b-lg" }, [
            !_vm.deliverySelectedProducts.length
              ? _c(
                  "div",
                  { staticClass: "empty-products text-center" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-basic m-b-xl",
                        attrs: {
                          to: {
                            name: "Delivery Requests",
                            params: { tab: "delivery-request-list" }
                          }
                        }
                      },
                      [_vm._v("一覧へ戻る")]
                    )
                  ],
                  1
                )
              : _c("div", [
                  _c("div", { staticClass: "m-b-md" }, [
                    _vm._v(
                      "\n        納品依頼登録をするためには、納品予定数を入力後に登録ボタンを押してしてください。\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "list-products" }, [
                    _c("div", { staticClass: "selected-products-header" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-selected-products" }, [
                      _c("table", { staticClass: "table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "w-120",
                                staticStyle: { "text-align": "center" }
                              },
                              [_vm._v("納品する商品")]
                            ),
                            _vm._v(" "),
                            _c("th", { staticClass: "item-name-head" }),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticClass: "w-120 item-quantity-head" },
                              [_vm._v("納品予定数")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticClass: "w-220 item-fnsku-head p-l-24" },
                              [_c("fnsku-kbn-thead")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass:
                                  "w-200 item-good-label-attachkbn-head p-l-24"
                              },
                              [_c("goods-label-thead")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "w-200 expiration-date-head p-l-24"
                              },
                              [_c("due-date-management-thead")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticClass: "w-220 shipping-packing-head" },
                              [_c("shipping-packing-thead")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "w-100",
                                staticStyle: { "text-align": "center" }
                              },
                              [_vm._v("操作")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.deliverySelectedProducts, function(
                            deliverySelectedProduct,
                            deliverySelectedProductIndex
                          ) {
                            return _c(
                              "tr",
                              { key: deliverySelectedProductIndex },
                              [
                                _c("td", { staticClass: "text-center" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "box-selected-product-image w-40"
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "selected-product-image img-responsive",
                                        attrs: {
                                          src: deliverySelectedProduct.image,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class:
                                        "box-delivery-judgment-status " +
                                        _vm.getJudgmentStatusClass(
                                          deliverySelectedProduct.status
                                        )
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          deliverySelectedProduct.status_str
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("div", { staticClass: "m-b-xs" }, [
                                    _vm._v(
                                      _vm._s(deliverySelectedProduct.itemName)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(deliverySelectedProduct.asin))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "td-vertical-top" }, [
                                  _c("div", { staticClass: "h-30" }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: deliverySelectedProduct.quantity,
                                        expression:
                                          "deliverySelectedProduct.quantity"
                                      }
                                    ],
                                    staticClass:
                                      "form-control expected-delivery-number text-right",
                                    class: parseInt(
                                      deliverySelectedProduct.quantity
                                    )
                                      ? ""
                                      : "bg-no-input",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: deliverySelectedProduct.quantity
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          deliverySelectedProduct,
                                          "quantity",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.validateErrors.quantity[
                                    deliverySelectedProduct.asin
                                  ] &&
                                  _vm.validateErrors.quantity[
                                    deliverySelectedProduct.asin
                                  ].length
                                    ? _c("div", { staticClass: "text-red" }, [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.validateErrors.quantity[
                                                deliverySelectedProduct.asin
                                              ][0]
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "fnsku-kbn-td td-vertical-top p-l-24"
                                  },
                                  [
                                    _c("fnsku-kbn-item", {
                                      attrs: {
                                        product: deliverySelectedProduct,
                                        isEdit: true
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "td-vertical-top",
                                    attrs: { colspan: "3" }
                                  },
                                  [
                                    _c("div", { staticClass: "box-colspan" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "box-product-label-attach-kbn w-200 p-l-16"
                                        },
                                        [
                                          _c("div", { staticClass: "h-30" }),
                                          _vm._v(" "),
                                          _c("goods-label-attach-kbn-item", {
                                            attrs: {
                                              product: deliverySelectedProduct
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "box-due-date-manage w-200 p-l-24"
                                        },
                                        [
                                          _c("due-date-management-item", {
                                            key:
                                              "due-date-manage-" +
                                              deliverySelectedProduct.asin,
                                            attrs: {
                                              product: deliverySelectedProduct
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.validateErrors.dueDateManagement[
                                            deliverySelectedProduct.asin
                                          ] &&
                                          _vm.validateErrors.dueDateManagement[
                                            deliverySelectedProduct.asin
                                          ].length
                                            ? _c(
                                                "div",
                                                { staticClass: "text-red" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.validateErrors
                                                          .dueDateManagement[
                                                          deliverySelectedProduct
                                                            .asin
                                                        ][0]
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "box-shipping-packing w-220 p-l-8"
                                        },
                                        [
                                          _c("div", { staticClass: "h-30" }),
                                          _vm._v(" "),
                                          _c("shipping-packing-item", {
                                            key:
                                              "shipping-packing-" +
                                              deliverySelectedProduct.asin,
                                            attrs: {
                                              product: deliverySelectedProduct,
                                              isEdit: true
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "m-t-xs availability-date p-l-16",
                                        class: [
                                          _vm.getAvailabilityDate(
                                            deliverySelectedProduct
                                          )
                                            ? ""
                                            : "availability-date-visibility"
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                    出荷可能期限日：" +
                                            _vm._s(
                                              _vm.getAvailabilityDate(
                                                deliverySelectedProduct
                                              )
                                            ) +
                                            "までの注文に対して出荷することができます。\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "td-vertical-top text-center"
                                  },
                                  [
                                    _c("div", { staticClass: "h-30" }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-delete-selected-product",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.deleteDeliverySelectedProduct(
                                              deliverySelectedProduct
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("削除")]
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center m-b-md" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-basic m-r-sm",
                          attrs: {
                            to: {
                              name: "Delivery Requests",
                              params: { tab: "delivery-request-list" }
                            }
                          }
                        },
                        [_vm._v("一覧へ戻る")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary custom-btn-delivery",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.submitValidate()
                            }
                          }
                        },
                        [_vm._v("登録")]
                      )
                    ],
                    1
                  )
                ])
          ]),
          _vm._v(" "),
          _vm.openDeliveryInfoModal
            ? _c("delivery-info-modal", {
                ref: "deliveryInfoModal",
                on: {
                  close: _vm.closeModalDeliveryInfo,
                  openModalRegisterDeliveryInfo:
                    _vm.openModalRegisterDeliveryInfo,
                  setDefaultInfoSuccess: _vm.setDeliverySellerInfo
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.openRegisterDeliveryInfoModal
            ? _c("register-delivery-info-modal", {
                ref: "registerDeliveryInfoModal",
                on: {
                  close: _vm.closeModalRegisterDeliveryInfo,
                  updatedDeliveryInfo: _vm.updatedDeliveryInfo
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.openDeliveryProductAddModal
            ? _c("delivery-product-add", {
                ref: "deliveryProductAddModal",
                attrs: { deliverySelectedProducts: _vm.selectedProducts },
                on: {
                  close: _vm.closeModalDeliveryProductAdd,
                  handleSelectedProduct: _vm.handleDeliverySelectedProduct,
                  handleSelectedProducts: _vm.handleDeliverySelectedProducts
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.openDeliveryProductsAddConfirmModal
            ? _c("modal-confirm", {
                attrs: { message: _vm.deliveryProductsAddConfirmMessage },
                on: {
                  confirm: _vm.deliveryProductsAdd,
                  close: _vm.closeModalConfirmDeliveryProductsAdd
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.openAlertDeliveryProductsAddedModal
            ? _c("modal-alert", {
                attrs: {
                  message: _vm.alertDeliveryProductsAddedMessage,
                  customHide: true,
                  modalWidth: 550
                },
                on: { close: _vm.closeModalAlertProductsAdded }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.openAlertValidateFailsModal
            ? _c("modal-alert", {
                attrs: {
                  message: _vm.alertValidateFailsMessage,
                  customHide: true
                },
                on: { close: _vm.closeModalAlertValidateFails }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "delivery-name" }, [
        _c("strong", [_vm._v("納品名")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "delivery-date" }, [
        _c("strong", [_vm._v("納品予定日")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2 col-lg-1 w-150" }, [
      _c("div", { staticClass: "m-b-sm" }, [
        _c("strong", [_vm._v("発送元情報")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "m-b-xl" }, [
      _c("strong", [_vm._v("商品選択より、納品する商品を選択してください。")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8790f7d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8790f7d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/UpdateDeliveryRequestRegistration.vue
// module id = null
// module chunks = 